// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.n0qJ8e_hWTufIoXedBO0 {
    margin-left: 0.5em;
}

.hqD8B4dm77YQ7GRwGPDD {
    display: flex;
    flex-direction: row;
}

._zcIrm4wPuBF2ijwolnq {
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/admin/interests/result-table.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".indent {\n    margin-left: 0.5em;\n}\n\n.inline-flex {\n    display: flex;\n    flex-direction: row;\n}\n\n.pointer {\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"indent": `n0qJ8e_hWTufIoXedBO0`,
	"inline-flex": `hqD8B4dm77YQ7GRwGPDD`,
	"inlineFlex": `hqD8B4dm77YQ7GRwGPDD`,
	"pointer": `_zcIrm4wPuBF2ijwolnq`
};
export default ___CSS_LOADER_EXPORT___;
